export const ProductCommissions = () => {
  return <h1>Commissions</h1>;
};
